import extractOptions from "./extractOptions";

const ELEMENT_SELECTOR = '[data-search-dropdown]';

import SearchDropdown from './search-dropdown';

export function exec(){
    const searchDropDownElements = document.querySelectorAll(ELEMENT_SELECTOR);
    // convert to array for IE11 (no support for foreach on NodeList)
    const searchDropDownElementsArray = Array.prototype.slice.call(searchDropDownElements);

    searchDropDownElementsArray.forEach(function(element) {
        const options = Object.assign(
            {},
            SearchDropdown.DEFAULTS,
            extractOptions("search-dropdown", element)
        );
        const instance = new SearchDropdown(element, options);
        element.searchDropdown = instance;
    });
};

export {exec as default};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/search-dropdown/index.js